// extracted by mini-css-extract-plugin
module.exports = {"footer":"DefaultFooter_footer__1GusO"};